import React from 'react';

import AccommodationPropertyContentSelection from './AccommodationPropertyContentSelection';
import AccommodationPropertyGeneratedContent from './AccommodationPropertyGeneratedContent';

export default function AccommodationPropertyDetailsSection() {
  return (
    <>
      <AccommodationPropertyGeneratedContent />
      <AccommodationPropertyContentSelection />
    </>
  );
}
